setTimeout(() =>{

  let _grid_product = document.querySelectorAll('.isp_grid_product')

  if (_grid_product.length ) {
    _grid_product.forEach( async (e)=>{
      let productId = e.getAttribute('product_id')
      let price = e.querySelector('.isp_product_price.money')
      
      if (price) {
        price.setAttribute('bss-b2b-product-id', productId)
        price.setAttribute('bss-b2b-product-price', '')
       const res = await BSS_B2B.storage.productStorage.load();
                BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', res)
      }
    })
  }
  }, 2500)